<template>
  <div class="dashboard-device">
    <div class="dashboard-device-image" :class="{'-mobile': device.type !== 'extension'}">
      <img v-if="device.type === 'extension'" :src="device.locked ? require('../assets/img/desktop-locked.png') : require('../assets/img/desktop-unlocked.png')" alt="icon">
      <img v-else :src="device.locked ? require('../assets/img/mobile-locked.png') : require('../assets/img/mobile-unlocked.png')" alt="icon">
    </div>
    <button @click="openDevice(deviceID)" class="dashboard-device-settings"><i class="icon-settings-bold"></i>{{$lang.messages.dashboard.device.settings}}</button>
    <div class="dashboard-device-name">
      {{device.name || 'Desktop 1'}} <br>
    </div>
    <LockDeviceSwitcher :deviceItem="device" :deviceID="deviceID" @togglekidsmode="sendToggleKidsModeEvent"/>
    <div class="dashboard-device-label" v-if="currentDeviceID === deviceID">
      {{$lang.messages.dashboard.device.you_here}}
    </div>
  </div>
</template>

<script>
import LockDeviceSwitcher from "@/components/LockDeviceSwitcher";
export default {
  name: 'DashboardDevice',
  props: ['deviceID', 'device', 'currentDeviceID'],
  methods: {
    openDevice(deviceID){
      this.$router.push({path: `device/${deviceID}`})
    },
    sendToggleKidsModeEvent(deviceID, newSetting){
      this.$emit('toggle-kids-mode', deviceID, newSetting)
    }
  },
  components: {
    LockDeviceSwitcher
  }
}

</script>